<template>




<v-form v-model="valid">
  <v-container>



<v-banner single-line>
    <v-icon
      slot="icon"
      color="warning"
      size="25"
    >
      mdi-television
    </v-icon>
    Smart Dismissal Board
    <template v-slot:actions>

        <vue-identify-network>
  <template #unknown>
  </template>
  <template #slow>
        <v-banner
    single-line
  >
    <v-icon
      slot="icon"
      color="red"
      size="25"
    >
       mdi-wifi-strength-alert-outline
    </v-icon>
    Slow internet detected
  </v-banner>
  </template>
  <template #fast>

  
    <v-banner
    single-line
  >
    <v-icon
      slot="icon"
      color="green"
      size="36"
    >
      mdi-antenna
    </v-icon>
    Good internet detected
  </v-banner>
  </template>
</vue-identify-network>
      
<v-btn
  elevation="2"
  v-on:click="goToConciergePad"
  color="warning"
  outlined
>Logout
      <v-icon
        right
        dark
      >
        mdi-exit-to-app
      </v-icon>
      </v-btn>
    </template>
  </v-banner>



      
<v-btn
  elevation="2"
  v-on:click="openControlPanel"
  outlined
  light
  v-if="!openPanel"
>Open Panel


 <v-icon
        right
        dark
      >
       mdi-open-in-app
      </v-icon>
</v-btn>

<v-spacer></v-spacer>
<v-spacer></v-spacer>

 <v-alert v-if="boardOff"
      dense
      type="error"
    >
      Your Smart Board is <strong>NOT ACTIVE</strong>.  Please select Carline Run and Filter and click on <strong>ADD TO VIEW</strong> button.
    </v-alert>
    <v-alert v-if="boardOn"
      dense
      text
      type="success"
    >
      Your Smart Board is <strong>ACTIVE</strong>.  Please monitor board or listen to bell sound when student is on board..
    </v-alert>

   


<v-card
    class="mx-auto"
    max-width="344"
    outlined
    v-if="openPanel"
  >

  <v-card-title>
      CONTROL PANEL
  </v-card-title>
  <v-card-subtitle>
      Select Carline Run and the Filter Type
  </v-card-subtitle>
  <v-card-text>
     <v-combobox
          v-model="dropdownRun"
          :items="runArray"
          label="Select Carline Run"
    ></v-combobox>

    <v-btn
  elevation="2"
  v-on:click="getCurrentRefresh"
  outlined
   color="warning"
>Get Latest Run
 <v-icon
        right
        dark
      >
        mdi-refresh
      </v-icon>
</v-btn>
</v-card-text>

 <!--<v-card-text>

  <v-switch
      v-model="bellSwitch"
      inset
      label= "By Grade"
      color="pink"
    ></v-switch>

</v-card-text>-->

 <v-card-text>
     <v-combobox
          v-model="dropdownHomeroom"
          :items="homeroomArray"
          label="Select Homeroom or Grade"
          multiple
          v-on:change="clearValue()"
    ></v-combobox>

    
</v-card-text>
    <v-card-actions>


<v-btn
  elevation="2"
  v-on:click="selectRun"
  color="primary"
>Add to view</v-btn>

<v-btn
  elevation="2"
  v-on:click="closePanel"
  outlined
  light
>Close Panel
 <v-icon
        right
        dark
      >
        mdi-close
      </v-icon>
</v-btn>


    </v-card-actions>
 
  </v-card>

 
 <v-dialog
      v-model="dialog"
      persistent
      max-width="360"
    >

    <v-card
    class="mx-auto"
    max-width="360"
    outlined
    v-if="openPanel"
  >
  <v-card-title>
      WELCOME
  </v-card-title>
  <v-card-subtitle>
      Select Carline Run and the Filter Type to START
  </v-card-subtitle>
  <v-card-text>
     <v-combobox
          v-model="dropdownRun"
          :items="runArray"
          label="Select Carline Run"
    ></v-combobox>

    <v-btn
  elevation="2"
  v-on:click="getCurrentRefresh"
  outlined
   color="warning"
>Get Latest Run
 <v-icon
        right
        dark
      >
        mdi-refresh
      </v-icon>
</v-btn>
</v-card-text>

 <v-card-text>
     <v-combobox
          v-model="dropdownHomeroom"
          :items="homeroomArray"
          multiple
          label="Select Homeroom or Grade"
          v-on:change="clearValue()"
    ></v-combobox>

    
</v-card-text>
    <v-card-actions>


<v-btn
  elevation="2"
  v-on:click="selectRun"
  color="success"
>Complete</v-btn>



    </v-card-actions>
 
  </v-card>


 <!--<v-stepper
    v-model="e6"
    vertical
  >
    <v-stepper-step
      :complete="e6 > 1"
      step="1"
    >
      Select a Run
      <small>If you are not sure, just leave Run 1</small>
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-combobox
          v-model="dropdownRun"
          :items="runArray"
          label="Select Carline Run"
    ></v-combobox>
      <v-btn
        color="primary"
        @click="e6 = 2"
      >
        Continue
      </v-btn>
   
    </v-stepper-content>

    <v-stepper-step
      :complete="e6 > 2"
      step="2"
    >
      Select Homeroom(s) or Grade(s)
    </v-stepper-step>

    <v-stepper-content step="2">
       <v-combobox
          v-model="dropdownHomeroom"
          :items="homeroomArray"
          multiple
          label="Select Filter"
          v-on:change="clearValue()"
    ></v-combobox>
  

        <v-btn
        elevation="2"
        v-on:click="selectRun"
        color="success"
        >Complete</v-btn>
     
    </v-stepper-content>



 

    
  </v-stepper>-->
  </v-dialog>




  <v-divider></v-divider>

    

<v-chip-group>
  <v-chip
      class="ma-2"
      color="green"
      text-color="white"
    >
    {{selectedRun}}
    </v-chip>
 <v-chip
      class="ma-2"
      color="orange"
      text-color="white"
    >
    {{selectedHomeroom}}
    </v-chip>
    </v-chip-group>

   

     <!--<v-switch
      v-model="historySwitch"
      inset
      label= "Marked as Sent"
    ></v-switch>-->

    <v-switch
      v-model="bellSwitch"
      inset
      label= "Play Bell"
      color="yellow"
    ></v-switch>






  <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      >
    </v-text-field>




<v-data-table
    v-model="selectedRow"
    :headers="headers"
    :items-per-page="itemsPerPage"
    :items="items"
    item-key="id"
    class="elevation-1"
    @click:row="rowClick"
    :search="search"
  >


    

    <template v-slot:item.pickuP_FLAG="{ item }">

       <v-icon
      large
      color="green darken-2"
      v-if="item.pickuP_FLAG == 'L'" 
    >
      mdi-thumb-up
    </v-icon>

     <v-icon 
      large
      color="green darken-2"
      v-if ="item.pickuP_FLAG == 'Y'"
    >
      mdi-flag
    </v-icon>

     <v-icon 
      large
      color="red"
      v-if ="item.pickuP_FLAG == 'A'"
    >
     mdi-account-cancel
    </v-icon>

     <v-icon 
      large
      color="purple"
      v-if ="item.pickuP_FLAG == 'E'"
    >
     mdi-logout
    </v-icon>
    
 </template>


 <!--<template   v-slot:item.visitoR_IMAGE="{ item }">


      <v-avatar v-if ="item.visitoR_IMAGE != null">
      <img
        :src="item.visitoR_IMAGE"
        alt="My Image"
        size="36"
      >
    </v-avatar>

    </template>-->

<template v-slot:item.firsT_NAME="{ item }">
<p style="font-weight: bold; font-size: 200% ; color: black">
      {{ item.firsT_NAME }}
      </p>
 </template>

 <template v-slot:item.lasT_NAME="{ item }">
<p style="font-weight: bold; font-size: 200%; color: black">
      {{ item.lasT_NAME }}
      </p>
     
 </template>

  <template v-slot:item.entrY_TIME="{ item }">
    
      {{ formatDate(item.entrY_TIME) }}

 </template>

  <template v-slot:item.id="{ item }">


          <v-btn v-if="item.pickuP_FLAG != 'L' && item.pickuP_FLAG != 'Y' && item.pickuP_FLAG != 'A' && item.pickuP_FLAG != 'E'"   color="primary"  small v-on:click='patchToApi(
          item.id
          )'>Send</v-btn>

             <v-btn text v-if="item.pickuP_FLAG != 'L' && item.pickuP_FLAG != 'Y' && item.pickuP_FLAG != 'A' && item.pickuP_FLAG != 'E'"  color="error"  small v-on:click='absentToApi(
          item.id
          )'>Absent</v-btn>


           <v-btn
              v-if="item.pickuP_FLAG == 'L' || item.pickuP_FLAG == 'Y' || item.pickuP_FLAG == 'A' || item.pickuP_FLAG == 'E'"
              color="gray"
              fab
              small
              v-on:click='undoToApi(
          item.id
          )'>
 
        <v-icon>mdi-undo</v-icon>
        </v-btn>
{{spacer}}
        <v-chip v-if="item.pickuP_FLAG == 'Y'" 
        color="green"
        dark
        small
        >
         *Loaded
      </v-chip>

      <v-chip v-else-if="item.pickuP_FLAG == 'L'" 
        color="info"
        dark
        small
        >
         *Sent
      </v-chip>

       <v-chip v-else-if="item.pickuP_FLAG == 'E'" 
        color="purple"
        dark
        small
        >
         *Early Release
      </v-chip>

       <v-chip v-else-if="item.pickuP_FLAG == 'A'" 
        color="red"
        dark
        small
        >
         *Absent
      </v-chip>

  </template>



 <template v-slot:item.homeroom="{ item }">
      <v-chip
        color="orange"
        dark
      >
        {{ item.homeroom }}
      </v-chip>
      </template>

      <template v-slot:item.pickuP_METHOD="{ item }">
      <v-chip v-if="item.pickuP_METHOD == 'Bus'" 
        color="red"
        dark
      >
        {{ item.pickuP_METHOD }}
       
      </v-chip>
      <v-chip v-if="item.pickuP_METHOD == 'Car'" 
        color="blue"
        dark
      >
        {{ item.pickuP_METHOD }}
      </v-chip>

       <v-chip v-if="item.pickuP_METHOD == 'Walk or Bike Home'" 
        color="pink"
        dark
      >

        {{ item.pickuP_METHOD }}
      </v-chip>

      <v-chip v-if="item.pickuP_METHOD == 'Walker'" 
        color="pink"
        dark
      >

        {{ item.pickuP_METHOD }}
      </v-chip>
        <v-chip v-if="item.pickuP_METHOD == 'Walk-in'" 
        color="purple"
        dark
      >
        {{ item.pickuP_METHOD }}
      </v-chip>
       <v-chip v-if="item.pickuP_METHOD == 'Student'" 
        color="light-blue"
        dark
      >

        {{ item.pickuP_METHOD }}
      </v-chip>
       <v-chip v-if="item.pickuP_METHOD == 'Bridge'" 
        color="brown"
        dark
      >
        {{ item.pickuP_METHOD }}
      </v-chip>

       <v-chip v-if="item.pickuP_METHOD == 'Aftercare'" 
        color="green"
        dark
      >
        {{ item.pickuP_METHOD }}
      </v-chip>

      
      </template>





  


  </v-data-table>
<v-progress-linear v-if="loading"
      indeterminate
      color="pink"
      buffer-value="0"
    ></v-progress-linear>



<v-divider></v-divider>




     <!--<v-sparkline
      :fill="fill"
      :gradient="gradient"
      :line-width="width"
      :padding="padding"
      :smooth="radius || false"
      :value="sprinkleArray"
      :type="type"
      :gradient-direction="gradientDirection"
      auto-draw
    ></v-sparkline>-->





    </v-container>
  </v-form>


</template>


<script>

  import axios from 'axios';
  import moment from 'moment-timezone';

   const gradients = [
    ['#222'],
    ['#42b3f4'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#f72047', '#ffd200', '#1feaea'],
  ]

  export default {
    data: () => ({

      drawer: false,
        itemsDrawer: [
          { title: 'Go to Main', icon: 'mdi-account-plus', route:'https://www.conciergepadedu.com/login' },
        ],
        color: 'primary',
        colors: [
          'primary',
          'blue',
          'success',
          'red',
          'teal',
        ],
        versionNo: 'v 1.0.3',
        e1: 1,
        right: false,
        value: 0,
        query: false,
        missingStudents: 0,
        show: true,
        showErrors: true,
        boardOff: true,
        boardOn: false,
        dialog: false,
          e6: 1,
        historySwitch: false,
        bellSwitch: false,
        clipped: true,
        spacer: '  ',
        openPanel: true,
        permanent: false,
        miniVariant: false,
        progressValue: 0,
        selectedHomeroom: '',
        expandOnHover: false,
        background: false,
        singleSelect: true,
        selected: "Run 1",
        loading: false,
        selectedRow: [],
        itemsPerPage: 30,
        headers: [
          { text: '', value: 'pickuP_FLAG' },
          { text: '', value: 'firsT_NAME' },
          { text: '', value: 'lasT_NAME' },
          { text: 'Entry', value: 'entrY_TIME' },
          { text: 'Lane', value: 'lane' },
          { text: 'Slot', value: 'slot' },
          { text: '', value: 'id' },
          { text: '', value: 'pickuP_METHOD' },
          { text: '', value: 'homeroom' },
          { text: 'Sent', value: 'username' },
         
        ],

      fill: false,
      gradient: gradients[4],
      gradients,
      padding: 3,
      radius: 10,
      sprinkleArray: [],
      width: 2,
      type: 'trend',
      gradientDirection: 'top',
      search: '',
    snackbar: false,
    text: 'New Student ready to be dismissed.',
    timeout: 2000,
    studentExists: true,
    selectedRun: '',
    companyName: '',
    studentId:'',
    studentDob: '',
    validStudent: false,
    invalidStudent: false,
    selectedHomeoom: '',
    guardianFirstName: '',
    studentsAttached: [],
    guardianLastName: '',
    guardianRelation: '',
    guardianEmail: '',
    guardianPhone: '',
    dropdownRun: 'Run 1',
    loginUuid:'',
    runArray: [],
    bellIsOne: false,
    validUpdate: false,
    invalidUpdate: false,
    validEmailGuardian: false,
    invalidEmailGuardian: false,
    alreadyRegistered: '',
    studentArray: [],
    homeroomTemp: [],
    homeroomItems: [],
    homeroomArray: [],
    missingArray: [],
    missing: false,
    justIn: 0,
    currentStudents: 0,
    dropdownHomeroom: '',
    addStudentArray: '',
    hangerIdArray: [],
      passwordAlert: false,
      message: '',
      alert: false,
      loaded: false,
      results: {},
      firstName: '',
      _isMounted:false,
      pId: '',
      compName: '',
      currentArray: [],
      currentItems: '',
      currentStatus: '',
      hagnerId: '',
      jwsToken: '',
      username: '',
      password: '',
      reTypePassword: '',
      switchSave: '',
      connectArray: [],
      valid: true,
      validCode: false,
      invalidCode: false,
      isFetching: false,
      ifdata: false,
      carlineArray: [],
      carlineRun: [],
      useSync: "N",
      syncArray: [],
      doAdd: "N",
      items: [],
      timer:0,
      counter: "",
      message2: "",
      interv: "",
      students: [],
      name: '',
      accessToken: '',
      my_timer :0,
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    created: function() {

       

    },

    mounted: function() {

     this.jwsToken = localStorage.getItem('jwsToken');

     //console.log("This is the jws token: " + this.jwsToken);

     this.companyName = this.$route.query.uuid;

     this.username = this.$route.query.user;

     if (this.username.length == 0) {

       this.dialog = false;

       this.goToConciergePad();

       this.username = 'unknown';
     } else {

        this.dialog = true;
     }
     //this.username = store.state.userName;


     //this.getStudents();

     this._isMounted = true;

     this.getCurrentRun();
     this.getHomeroom();
     //this.getHomeroomRead();
     //this.getBoardSync(this.companyName);

     //this.getCarlineAll();

  },
  
   beforeDestroy: function(){

      clearInterval(this.$options.interval)

      this.pauseTimer();

      //console.log('DESTROYYYY!!!')
  },

    methods: {

    startInterval: function () {

              /*this.my_timer = setInterval(() => {
                        this.getCarlineLoop();
                 }, 3000);*/
    //console.log("Setting the interval");

    this.$options.interval = setInterval(this.getCarlineLoop, 3200)
    // Ok? What about check if timer works?
    // And it's not reactive so you should create data option
    console.log(this.$options.interval !== null)  



  },
  log () {
      console.log('Hello world')
    },
  clearValue() {

    //console.log("changed")
    this.justIn = 0;
    this.currentStudents = 0;

  },
  pauseTimer() {
     clearInterval(this.my_timer);
   },
  closePanel: function() {

      this.openPanel = false;

  },
  openControlPanel: function() {

      this.openPanel = true;

  },


   selectRun:  function () {

       


       if (this.dropdownRun.length > 0 && this.dropdownHomeroom.length > 0) {
      
       this.dialog = false;
       this.justIn = 0;
       this.currentStudents = 0;
       this.selectedRun = this.dropdownRun;
       this.selectedHomeroom = this.dropdownHomeroom;

       //console.log("This is the format of the homeroom array selected: " + this.selectedHomeroom);

      if (this.selectedRun.length > 0 && this.selectedHomeroom.length > 0) {

        this.dialog = false;
        this.boardOff = false
        this.boardOn = true;

          var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");
          this.postConnect(this.username,this.companyName,newDate,this.selectedHomeroom,this.selectedRun)

      }

       this.startInterval();

     }

   },
   goToConciergePad: function() {


       clearInterval(this.my_timer);

       //console.log('Logging out')

       this.$router.push('Carline');

       //window.location.href = "https://www.conciergepadedu.com/login";


   },
  postConnect(user,comp,dateAdded,boardSelection,run) {

    this.connectArray = [];

    /*const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };*/

//{USERNAME}/{COMPANY_NAME}/{BOARD_SELECTION}/{CARLINE_RUN}/{ENTRY_TIME}
  axios.get('https://api.conciergepadedu.com/api/Connects/InsertHomeroom/' + user + '/' + comp + '/' + boardSelection + '/' + run + '/' + dateAdded).then(response => {


      if (response.data.error) {

          console.log('error', response.data.error);



      } else {

          //console.log('success', response.data);

          this.connectArray = response.data;
   
      
      } 

  

        }).catch(error => {

            console.log(error.response);


        });

 

  },

   getBoardSync(comp) {

    this.syncArray = [];

    /*const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };*/

//{USERNAME}/{COMPANY_NAME}/{BOARD_SELECTION}/{CARLINE_RUN}/{ENTRY_TIME}
  axios.get('https://api.conciergepadedu.com/api/SyncMaints/GetBoardSync/' + comp).then(response => {


      if (response.data.error) {

          //console.log("ERROR")
          //console.log('error', response.data.error);
          this.syncArray = [];
          this.useSync = "N";



      } else {

      //console.log('success', response.data);


      this.syncArray = response.data;

      if (this.syncArray.length > 0) {

        this.useSync = "Y";
      } else {

         this.useSync = "N";
      }
   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);
            this.syncArray = [];
            this.useSync = "N";


        });

 

  },

  getMissing(comp,run) {

    this.missingArray = [];

    /*const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };*/

//{USERNAME}/{COMPANY_NAME}/{BOARD_SELECTION}/{CARLINE_RUN}/{ENTRY_TIME}
  axios.get('https://api.conciergepadedu.com/api/Connects/GetMissingTotal/' + comp + '/' + run ).then(response => {


      if (response.data.error) {

          //console.log("ERROR")
          console.log('error', response.data.error);



      } else {

      //console.log('success in missing students', response.data);

      this.missingArray = response.data;

      if (this.missingArray.length > 0) {

        this.missingStudents = this.missingArray[0].homerooM_COUNT;
        this.missing = true

        if (this.missingStudents == 0) {

          this.missing = false;
          
        }
      } else {

        this.missing = false;
      }
   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);


        });

 

  },
   getCarlineLoop() {

    var timeOfDay = moment().tz("America/New_York").format("HH");

     if (timeOfDay == 21) {

        console.log("I am in the off duty time")

        clearInterval(this.$options.interval);
        this.goToConciergePad();
        
        
     }

    if (timeOfDay == 22) {

        console.log("I am in the off duty time")

        clearInterval(this.$options.interval);
        this.goToConciergePad();
     }

     if (timeOfDay == 23) {

       console.log("I am in the off duty time")

        clearInterval(this.$options.interval);
        this.goToConciergePad();
     }

     if (timeOfDay == 24) {

       console.log("I am in the off duty time")

        clearInterval(this.$options.interval);
        this.goToConciergePad();
     }

    if (timeOfDay > 5 && timeOfDay < 21) {

      //console.log("execute 123456");
      //console.log("This is the selected: " + this.selectedHomeroom);
      //console.log("This is the selected length: " + this.selectedHomeroom.length);
      //console.log("This is boolean " + this.selectedHomeroom.includes("ALL"));

      if (this.dropdownRun.length > 0 && this.dropdownHomeroom.length > 0) {

       this.selectedRun = this.dropdownRun;
       this.selectedHomeroom = this.dropdownHomeroom;

        if (this.selectedRun.length > 0 && this.selectedHomeroom.length > 0) {

          this.boardOff = false
          this.boardOn = true;

          
        
        }

       

       if (this.switchSave != this.selectedHomeroom) {

           //console.log("Switched to: " + this.selectedHomeroom)

           this.switchSave = this.selectedHomeroom;
            this.currentStatus = '';
            this.currentItems = [];

            var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");
            this.postConnect(this.username,this.companyName,newDate,this.selectedHomeroom,this.selectedRun)
            

       }
     
       if (this.selectedHomeroom.includes("ALL") == true) {

           //console.log("I am in the ALL section");
           //console.log(`${this.historySwitch.toString()}`);

           if (`${this.historySwitch.toString()}` == "true") {

                this.currentStatus = '';
                this.currentItems = [];

               this.getCarSentAll();
              
           } else {

               this.getCarlineAll();
           }

       } else {

            if (`${this.historySwitch.toString()}` == "true") {

                this.currentStatus = '';
                this.currentItems = [];
                this.getCarSent();


           } else {

                //console.log("I am here in Homeroom")

              
                this.getCarByHrArray();
               //this.getCarByHr();
             


               
           }
            

       }


      

    } else {

       //console.log("dont execute");

       clearInterval(this.$options.interval);

    }


    
    }


   },
   getCurrentRefresh: function () {


            this.carlineArray = [];
            this.carlineRun = [];
            this.runArray = [];

            axios.get('https://api.conciergepadedu.com/api/Runs/GetCurrentRunWeb/' + this.companyName).then(response => {

                if (this._isMounted) {

                    if (response.data.error) {

                        //console.log(response.data.error);

                        //console.log("############# ERROR #################")

                        this.isFetching = false;
                        this.ifdata = false;

                    } else {

                        this.carlineArray = response.data;

                        //console.log("############# SUCCESS getCurrentRefresh #################")

                        var x = 0;

                        for (var i = 0; i < this.carlineArray.length; i++) {

                            this.runArray.push(this.carlineArray[i].ruN_LABEL);

                            this.carlineRun.push({
                                label: this.carlineArray[i].ruN_LABEL,
                                value: this.carlineArray[i].ruN_LABEL
                            });

                            x = i;

                        }

                        console.log(x);
                        //console.log("Carline Run Data");
                        //console.log(this.carlineRun);

                        this.isFetching = false;
                        this.ifdata = true;

                    }

                }

            }).catch(error => {

                console.log(error.response);

                //console.log("############# CATCH #################")

                this.isFetching = false;
                this.ifdata = false;
                this.carlineArray = [];

            });

        },

        countDown() {
  var n = this.timer
  if (!this.counter) {
    this.counter = true;
  } else if (n > 0) {
    n = n - 1
    this.timer = n
    this.message2 = "You have " + n + "seconds left."
  } else {
    clearInterval(this.interv);
    this.counter = false
    this.message2 = "Your time is up!"
  }
},

startTimer() {
  this.interv = setInterval(this.countDown, 1000);
},

   getCurrentRun: function () {

       

            this.carlineArray = [];
            this.carlineRun = [];
            this.runArray = [];

            axios.get('https://api.conciergepadedu.com/api/Runs/GetCurrentRunWeb/' + this.companyName).then(response => {

                if (this._isMounted) {

                    if (response.data.error) {

                        //console.log(response.data.error);

                        //console.log("############# ERROR #################")

                        this.isFetching = false;
                        this.ifdata = false;

                    } else {

                        this.carlineArray = response.data;

                        //console.log("############# SUCCESS getCurrentRun #################")

                        var x = 0;

                        for (var i = 0; i < this.carlineArray.length; i++) {

                            this.runArray.push(this.carlineArray[i].ruN_LABEL);

                            this.carlineRun.push({

                                label: this.carlineArray[i].ruN_LABEL,
                                value: this.carlineArray[i].ruN_LABEL

                            });

                            x = i;

                        }

                        console.log(x);
                        //console.log("Carline Run Data");
                        //console.log(this.carlineRun);

                        this.selected = this.carlineArray[0].ruN_LABEL;
                        this.dropdownRun = this.carlineArray[0].ruN_LABEL;

                        //this.getMissing(this.companyName,  this.selected );
                        

                        this.isFetching = false;
                        this.ifdata = true;

                    }

                }

            }).catch(error => {

                console.log(error.response);

                //console.log("############# CATCH #################")

                this.isFetching = false;
                this.ifdata = false;
                this.carlineArray = [];

            });

        },

        getHomeroomRead() {

            this.homeroomTemp = [];
            this.homeroomItems = [];
            this.homeroomArray = [];


            axios.get('https://api.conciergepadedu.com/api/Homerooms/HomeroomInfoRead/' + this.companyName).then(response => {

                if (this._isMounted) {

                    if (response.data.error) {

                        //console.log(response.data.error);

                        //console.log("############# ERROR #################")

                        this.isFetching = false;
                        this.ifdata = false;

                    } else {

                        var x = 0;

                        this.homeroomTemp = response.data;

                        //console.log(response.data);

                        this.homeroomArray.push("ALL");

                        for (var i = 0; i < this.homeroomTemp.length; i++) {

                            this.homeroomItems.push(this.homeroomTemp[i].homeroom);
                            this.homeroomArray.push(this.homeroomTemp[i].homeroom);

                            x = i;

                        }

                        //console.log("IN THE HOMEROOM SECTION");
                        //console.log(this.homeroomArray);

                        console.log(x);

                    }

                }

            }).catch(error => {

                console.log(error.response);

                //console.log("############# CATCH #################")

                this.isFetching = false;
                this.ifdata = false;
                this.homeroomArray = [];

            });

        },

        getHomeroom() {

            this.homeroomTemp = [];
            this.homeroomItems = [];
            this.homeroomArray = [];


            axios.get('https://api.conciergepadedu.com/api/Homerooms/HomeroomInfoWeb/' + this.companyName).then(response => {

                if (this._isMounted) {

                    if (response.data.error) {

                        //console.log(response.data.error);

                        //console.log("############# ERROR #################")

                        this.isFetching = false;
                        this.ifdata = false;

                    } else {

                        var x = 0;

                        this.homeroomTemp = response.data;

                        //console.log(response.data);

                        this.homeroomArray.push("ALL");

                        for (var i = 0; i < this.homeroomTemp.length; i++) {

                            this.homeroomItems.push(this.homeroomTemp[i].homeroom);
                            this.homeroomArray.push(this.homeroomTemp[i].homeroom);

                            x = i;

                        }

                        //console.log("IN THE HOMEROOM SECTION");
                        //console.log(this.homeroomArray);

                        console.log(x);

                    }

                }

            }).catch(error => {

                console.log(error.response);

                //console.log("############# CATCH #################")

                this.isFetching = false;
                this.ifdata = false;
                this.homeroomArray = [];

            });

        },

    rowClick: function (item, row) {      
      row.select(true);
      console.log(item);
      //item  - selected item
    },
    selectStudent(myItem) {

      console.log(myItem);

    },

    getAll() {

            
            axios.get('https://api.conciergepadedu.com/api/Cars/GetDemeritAllWeb/' + this.companyName + '/' + this.selectedRun).then(response => {

               

                    if (response.data.error) {



                        console.log("############# ERROR #################")

     

                    } else {

                        //console.log("############# SUCCESSFUL #################");

                        this.items = response.data;

                        //console.log(response.data);

                      
                    }

                

            }).catch(error => {

                console.log(error.response);

                //console.log("############# CATCH #################")

               
            });

        },

    getData: async function () {


  try{
   let response =  await axios.get('https://api.conciergepadedu.com/api/Cars/GetDemeritAllWeb/' + this.companyName + '/' + this.selectRun)
      this.items = response.data;
  }catch(error) {
      //this.availabilityMessage = false;
      console.log(error);
    }
    },
  //return this.availabilityMessage;


    getCarlineAll: function () {

            const sendGetRequest = async () => {
            try {

          

            this.loading  = true;

            this.value =  0;
            this.query =  true;
            this.show =  true;
    
            const resp = await axios.get('https://api.conciergepadedu.com/api/Cars/GetDemeritAllWeb/' + this.companyName + '/' + this.selectedRun).then(response => {

                if (response.data.error) {

                    console.log(resp.data.error);
                    this.loading  = false;
                    this.value =  0;
                    this.query =  false;
                    this.show =  false;

                } else {

                     //console.log("############# SUCCESS getCarlineAll #################")
                     //console.log(response.data);

                    this.items = response.data;

                    //this.sprinkleArray.push(this.items.length);

                    this.value =  50;
                    this.query =  true;
                    this.show =  true;

                    if (`${this.bellSwitch.toString()}` == "true") {


                         this.justIn = this.items.length;

                         //console.log("JUST IN : " + this.justIn)
                         //console.log("Current Students In Queue" +  this.currentStudents)

                      if (this.justIn > this.currentStudents) {

                        this.currentStudents = this.justIn;

                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                      }

                     



                    
                    /*if (this.items.length < this.currentStatus){

                        this.currentStatus = this.items.length;
                      }

                    if (this.currentStatus == '') {

                      console.log("THIS IS THE FIRST PATH");
                      
                      this.currentArray.push(this.items.length);
                      this.currentItems  = this.currentArray[this.currentArray.length - 1];
                      this.currentStatus = this.currentArray[this.currentArray.length - 1];

                      if (this.currentItems == this.currentStatus) {

                            this.currentItems = this.currentItems + 1;
                      
                            var audio2 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                            audio2.play();
                      
                       }
                            

                    }
                      else if (this.items.length >  this.currentItems) {

                       //this.snackbar = true;
                       this.currentStatus = '';
                       //this.currentItems = [];
                       var audio1 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                       audio1.play();

                    } else {

                        console.log("Here is the ELSE")

                          

                      }*/

                         

                      
                    }
                    
                    else {

                          this.justIn = 0;
                          this.currentStudents = 0;

                    }

                    this.loading  = false;
                     this.value =  100;
                    this.query =  false;
                    this.show =  false;

                     

                }

            }).catch(error => {
                     console.log(error.response);
                     this.loading  = false;
            });
            

        
            } catch (err) {

            console.error(err);
            }
            };

            sendGetRequest();

        },

    getCarlineAllSync() {

    this.syncArray = [];

    /*const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };*/

//{USERNAME}/{COMPANY_NAME}/{BOARD_SELECTION}/{CARLINE_RUN}/{ENTRY_TIME}
  axios.get('https://api.conciergepadedu.com/api/Cars/GetDemeritAllWebSync/' + this.companyName + '/' + this.selectedRun).then(response => {


      if (response.data.error) {

           console.log(response.data.error);
                    this.loading  = false;
                    this.value =  0;
                    this.query =  false;
                    this.show =  false;




      } else {

     

                    //console.log("############# SUCCESS getCarlineAllSYNC #################")
                    //console.log(response.data);

                    this.items = response.data;

                    //this.sprinkleArray.push(this.items.length);

                    this.value =  50;
                    this.query =  true;
                    this.show =  true;

                    if (`${this.bellSwitch.toString()}` == "true") {


                         this.justIn = this.items.length;

                         //console.log("JUST IN : " + this.justIn)
                         //console.log("Current Students In Queue" +  this.currentStudents)

                      if (this.justIn > this.currentStudents) {

                        this.currentStudents = this.justIn;

                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                      }

                     



                    
                    /*if (this.items.length < this.currentStatus){

                        this.currentStatus = this.items.length;
                      }

                    if (this.currentStatus == '') {

                      console.log("THIS IS THE FIRST PATH");
                      
                      this.currentArray.push(this.items.length);
                      this.currentItems  = this.currentArray[this.currentArray.length - 1];
                      this.currentStatus = this.currentArray[this.currentArray.length - 1];

                      if (this.currentItems == this.currentStatus) {

                            this.currentItems = this.currentItems + 1;
                      
                            var audio2 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                            audio2.play();
                      
                       }
                            

                    }
                      else if (this.items.length >  this.currentItems) {

                       //this.snackbar = true;
                       this.currentStatus = '';
                       //this.currentItems = [];
                       var audio1 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                       audio1.play();

                    } else {

                        console.log("Here is the ELSE")

                          

                      }*/

                         

                      
                    }
                    
                    else {

                          this.justIn = 0;
                          this.currentStudents = 0;

                    }

                    this.loading  = false;
                    this.value =  100;
                    this.query =  false;
                    this.show =  false;
   

   
      
      
      } 

  

        }).catch(error => {

             console.log(error.response);
             this.loading  = false;


        });

 

  },


  

    getCarByHr:function() {



            const sendGetRequest = async () => {
            try {

              this.loading = true;


            
            const resp = await axios.get('https://api.conciergepadedu.com/api/Cars/GetCarlineHomeroomWeb/' + this.companyName + '/' + this.selectedRun + "/" + this.selectedHomeroom).then(response => {

                if (response.data.error) {

                          console.log(resp.data);
                          this.loading = false;

      

                } else {

                    this.items = response.data;

                    //this.sprinkleArray.push(this.items.length);

                    if (`${this.bellSwitch.toString()}` == "true") {


                        this.justIn = this.items.length;

                         //console.log("JUST IN : " + this.justIn)
                         //console.log("Current Students In Queue" +  this.currentStudents)

                      if (this.justIn > this.currentStudents) {

                        this.currentStudents = this.justIn;

                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                      }

                      /*if (this.items.length < this.currentStatus){

                        this.currentStatus = this.items.length;
                      }


                        if (this.currentStatus == '') {

                            this.currentArray.push(this.items.length);
                            this.currentItems  = this.currentArray[this.currentArray.length - 1];
                            this.currentStatus = this.currentArray[this.currentArray.length - 1];

                         }
                         else if (this.items.length > this.currentStatus) {

                       //this.snackbar = true;
                          this.currentStatus = '';
                          this.currentItems = [];
                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                          }

                          else if (this.currentItems ==  1) {

                          console.log("I am in the logic for 1 bell!!!!!!")
                      
                            this.currentItems = 2;
                      
                            var audio2 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                            audio2.play();

                      

                            console.log("This is current status: " +  this.currentStatus);
                            console.log("This is current items: " +  this.currentItems);

                        }*/

                    
                    
                    } else {

                        this.justIn = 0;
                        this.currentStudents = 0;

                    }

                this.loading = false;
                 

                }

           

            }).catch(error => {

                 console.log(error.response);
                 this.loading = false;


            });
            

        
            } catch (err) {

            console.error(err);
            }
            };

           sendGetRequest();

            
        },


      getCarByHrArray:function() {

            const sendGetRequest = async () => {
            try {

              this.loading = true;


            
            const resp = await axios.get('https://api.conciergepadedu.com/api/Cars/GetCarlineHomeroomArray/' + this.companyName + '/' + this.selectedRun + "/" + this.selectedHomeroom).then(response => {

                if (response.data.error) {

                          console.log(resp.data);
                          this.loading = false;

      

                } else {

                    this.items = response.data;

                    //this.sprinkleArray.push(this.items.length);

                    if (`${this.bellSwitch.toString()}` == "true") {


                        this.justIn = this.items.length;

                         //console.log("JUST IN : " + this.justIn)
                         //console.log("Current Students In Queue" +  this.currentStudents)

                      if (this.justIn > this.currentStudents) {

                        this.currentStudents = this.justIn;

                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                      }

                      /*if (this.items.length < this.currentStatus){

                        this.currentStatus = this.items.length;
                      }


                        if (this.currentStatus == '') {

                            this.currentArray.push(this.items.length);
                            this.currentItems  = this.currentArray[this.currentArray.length - 1];
                            this.currentStatus = this.currentArray[this.currentArray.length - 1];

                         }
                         else if (this.items.length > this.currentStatus) {

                       //this.snackbar = true;
                          this.currentStatus = '';
                          this.currentItems = [];
                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                          }

                          else if (this.currentItems ==  1) {

                          console.log("I am in the logic for 1 bell!!!!!!")
                      
                            this.currentItems = 2;
                      
                            var audio2 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                            audio2.play();

                      

                            console.log("This is current status: " +  this.currentStatus);
                            console.log("This is current items: " +  this.currentItems);

                        }*/

                    
                    
                    } else {

                        this.justIn = 0;
                        this.currentStudents = 0;

                    }

                this.loading = false;
                 

                }

           

            }).catch(error => {

                 console.log(error.response);
                 this.loading = false;


            });
            

        
            } catch (err) {

            console.error(err);
            }
            };

           sendGetRequest();

            
        },

        getCarByHrSync() {

        this.syncArray = [];

    /*const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };*/

//{USERNAME}/{COMPANY_NAME}/{BOARD_SELECTION}/{CARLINE_RUN}/{ENTRY_TIME}
  axios.get('https://api.conciergepadedu.com/api/Cars/GetCarlineHomeroomWebSync/' + this.companyName + '/' + this.selectedRun + "/" + this.selectedHomeroom).then(response => {


      if (response.data.error) {

           //console.log(response.data.error);
           this.loading = false;




      } else {

     

                    //console.log("############# SUCCESS getCarline HR SYNC #################")
                    //console.log(response.data);

                    this.items = response.data;

                    //this.sprinkleArray.push(this.items.length);

                    if (`${this.bellSwitch.toString()}` == "true") {


                         this.justIn = this.items.length;

                         //console.log("JUST IN : " + this.justIn)
                         //console.log("Current Students In Queue" +  this.currentStudents)

                      if (this.justIn > this.currentStudents) {

                        this.currentStudents = this.justIn;

                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                      }

                      /*if (this.items.length < this.currentStatus){

                        this.currentStatus = this.items.length;
                      }


                        if (this.currentStatus == '') {

                            this.currentArray.push(this.items.length);
                            this.currentItems  = this.currentArray[this.currentArray.length - 1];
                            this.currentStatus = this.currentArray[this.currentArray.length - 1];

                         }
                         else if (this.items.length > this.currentStatus) {

                       //this.snackbar = true;
                          this.currentStatus = '';
                          this.currentItems = [];
                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                          }

                          else if (this.currentItems ==  1) {

                          console.log("I am in the logic for 1 bell!!!!!!")
                      
                            this.currentItems = 2;
                      
                            var audio2 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                            audio2.play();

                      

                            console.log("This is current status: " +  this.currentStatus);
                            console.log("This is current items: " +  this.currentItems);

                        }*/

                    
                    
                    } else {

                        this.justIn = 0;
                        this.currentStudents = 0;

                    }

                this.loading = false;
                 

                    
   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);
            this.loading = false;



        });

 

  },


        getCarByGrade:function() {



            const sendGetRequest = async () => {
            try {

              this.loading = true;


            
            const resp = await axios.get('https://api.conciergepadedu.com/api/Cars/GetCarlineHomeroomWeb/' + this.companyName + '/' + this.selectedRun + "/" + this.selectedHomeroom).then(response => {

                if (response.data.error) {

                        console.log(resp.data);
                        this.loading = false;

      

                } else {

                    this.items = response.data;

                    //this.sprinkleArray.push(this.items.length);

                    if (`${this.bellSwitch.toString()}` == "true") {


                         this.justIn = this.items.length;

                         //console.log("JUST IN : " + this.justIn)
                         //console.log("Current Students In Queue" +  this.currentStudents)

                      if (this.justIn > this.currentStudents) {

                        this.currentStudents = this.justIn;

                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                      }

                      /*if (this.items.length < this.currentStatus){

                        this.currentStatus = this.items.length;
                      }


                        if (this.currentStatus == '') {

                            this.currentArray.push(this.items.length);
                            this.currentItems  = this.currentArray[this.currentArray.length - 1];
                            this.currentStatus = this.currentArray[this.currentArray.length - 1];

                         }
                         else if (this.items.length > this.currentStatus) {

                       //this.snackbar = true;
                          this.currentStatus = '';
                          this.currentItems = [];
                          var audio = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                          audio.play();

                          }

                          else if (this.currentItems ==  1) {

                          console.log("I am in the logic for 1 bell!!!!!!")
                      
                            this.currentItems = 2;
                      
                            var audio2 = new Audio('https://www.conciergepadedu.com/bells1.wav'); // path to file
                            audio2.play();

                      

                            console.log("This is current status: " +  this.currentStatus);
                            console.log("This is current items: " +  this.currentItems);

                        }*/

                    
                    
                    } else {

                        this.justIn = 0;
                        this.currentStudents = 0;

                    }

                this.loading = false;
                 

                }

           

            }).catch(error => {

                 console.log(error.response);
                 this.loading = false;


            });
            

        
            } catch (err) {

            console.error(err);
            }
            };

           sendGetRequest();

            
        },

        getCarSentAll: function () {

            

            const sendGetRequest = async () => {
            try {
            
            this.loading = true;

            const resp = await axios.get('https://api.conciergepadedu.com/api/Cars/GetCarlineHistoryAllWeb/' + this.companyName + '/' + this.selectedRun).then(response => {

                if (response.data.error) {

                     console.log(resp.data);
                     this.loading = false;

                } else {

                    

                    this.items = response.data;

                    this.loading = false;

                }

            }).catch(error => {

                console.log(error.response);
                this.loading = false;

            });
            

        
            } catch (err) {

            console.error(err);
            }
            };

            sendGetRequest();

            

        },

        getCarSent: function () {

            const sendGetRequest = async () => {
            try {
            
            const resp = await axios.get('https://api.conciergepadedu.com/api/Cars/GetCarlineHistoryWeb/' + this.companyName + '/' + this.selectedRun + "/" + this.selectedHomeroom).then(response => {

                if (response.data.error) {

                    //console.log("error")
                    console.log(resp.data);

                } else {

                    this.items = response.data;

                    if (this.items.temP_READING.length > 0) {

                            this.tempReading = true;

                        } else {

                            this.tempReading = false;
                        }
                }

            }).catch(error => {

                console.log(error.response);

            });
            

        
            } catch (err) {

            console.error(err);
            }
            };

            sendGetRequest();

            

        },

        formatDate(value) {
      return moment(value).format('hh:mm A')
        },

    uppercase() {
        

        if (this.studentId.length > 0 && this.studentDob.length > 9) {

          //console.log("In the validate student")

          this.validateStudent();

        } else {

          //this.invalidStudent = true;
          //this.validStudent = false;
        }
  },



  postStudent(studentId,companyName,dateAdded,logUuid,firstName,lastName,householdId,hangerId,grade,homeRoom,dob,removeDate) {

    const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };

  axios.post('https://api.conciergepadedu.com/api/Apps/StudentAdd',{ 
            STUDENT_ID: studentId,
            COMPANY_NAME: companyName,
            DATE_ADDED: dateAdded,
            LOGIN_UUID: logUuid,
            ACTIVE_FLAG: 'Y',
            FIRST_NAME: firstName,
            LAST_NAME: lastName,
            HOUSEHOLD_ID: householdId,
            HANGER_ID: hangerId,
            GRADE: grade,
            HOMEROOM: homeRoom,
            BIRTHDAY: dob,
            REMOVE_DATE: removeDate

      },auth).then(response => {


      if (response.data.error) {

          //console.log("ERROR")
          //console.log('error', response.data.error);

          this.validStudent = false;
          this.invalidStudent = true;


      } else {

      //console.log('success', response.data);
        this.validStudent = false;
        this.invalidStudent = false;

        this.addStudentArray = response.data;

        var hangerIdCheck = this.addStudentArray.householD_ID;

        this.getHangerId(this.studentId,hangerIdCheck,this.compName);


      if (hangerIdCheck !== '') {

        console.log("Student Added Successfully","Add","success");

      } else {

        console.log("No Household ID detected");

        //this.$alert("No Household ID detected","Add","error");
        
      }
   

   
      
      
      } 

  

        }).catch(error => {

              console.log(error.response);

              this.validStudent = false;
              this.invalidStudent = true;


        });

 

  },
  patchToApi(pId) {

            this.loading = true;

            /*const jsonPatchDocument = 
              {
                op:"replace",
                path:"/PICKUP_FLAG",
                value: "Q"
              };*/


            //note:auth will be 3rd parameter in post request
            axios.patch('https://api.conciergepadedu.com/api/Cars/PatchSlipWeb/' + pId, [{
                op:"replace",
                path:"/PICKUP_FLAG",
                value: "L"
              }]).then(response => {

                if (response.data.error) {

                    //console.log('error', response.data.error)
                    this.loading = false;

                } else {

                    //console.log('success', response.data)
                    this.loading = false;
                    this.currentStudents = this.currentStudents - 1;
                    this.getCarlineLoop();
                    

                }

            }).catch(error => {

                console.log(error.response)
                this.loading = false;

            });

        },
        absentToApi(pId) {

            this.loading = true;

            //note:auth will be 3rd parameter in post request
            axios.patch('https://api.conciergepadedu.com/api/Cars/PatchSlipWeb/' + pId, [{
                op:"replace",
                path:"/PICKUP_FLAG",
                value: "A"
              }]).then(response => {

                if (response.data.error) {

                    //console.log('error', response.data.error)
                    this.loading = false;

                } else {

                    //console.log('success', response.data)
                    this.loading = false;
                    this.currentStudents = this.currentStudents - 1;
                    this.getCarlineLoop();
                    

                }

            }).catch(error => {

                console.log(error.response)
                this.loading = false;

            });

        },
        undoToApi(pId) {

            this.loading = true;

            //note:auth will be 3rd parameter in post request
            axios.patch('https://api.conciergepadedu.com/api/Cars/PatchSlipWeb/' + pId, [{
                op:"replace",
                path:"/PICKUP_FLAG",
                value: ""
              }]).then(response => {

                if (response.data.error) {

                    //console.log('error', response.data.error)
                    this.loading = false;

                } else {

                    //console.log('success', response.data)
                    this.loading = false;
                    this.currentStudents = this.currentStudents - 1;
                    this.getCarlineLoop();
                    

                }

            }).catch(error => {

                console.log(error.response)
                this.loading = false;

            });

        },
    uploadToApi(pId,studentId,firstName,lastName,entryTime,schoolType,schoolCode,demeritCode,comments,pickupMethod,pickupFlag,gateNo,homeroom,hangerId,companyName,entryDate,doorbellValue,demeritDesc,pushToken,parentLastName,parentFirstName,tempLabel,tempReading,symptomValue,userName,carlineRun,lane,slot) {

            this.loading = true;

            //note:auth will be 3rd parameter in post request
            axios.put('https://api.conciergepadedu.com/api/Cars/PutSlipWeb/' + pId, {
                
                ID: pId,
                STUDENT_ID: studentId,
                FIRST_NAME: firstName,
                LAST_NAME: lastName,
                ENTRY_TIME: entryTime,
                SCHOOL_TYPE: schoolType,
                SCHOOL_CODE: schoolCode,
                DEMERIT_CODE: demeritCode,
                COMMENTS: comments,
                PICKUP_METHOD: pickupMethod,
                PICKUP_FLAG: pickupFlag,
                CARLINE_GATE_NO: gateNo,
                HOMEROOM: homeroom,
                HANGER_ID: hangerId,
                COMPANY_NAME: companyName,
                ENTRY_DATE: entryDate,
                DOORBELL_VALUE: doorbellValue,
                DEMERIT_DESC: demeritDesc,
                PUSH_TOKEN: pushToken,
                PARENT_LAST_NAME: parentLastName,
                PARENT_FIRST_NAME: parentFirstName,
                TEMP_LABEL: tempLabel,
                TEMP_READING: tempReading,
                SYMPTOM_VALUE: symptomValue,
                USERNAME: userName,
                CARLINE_RUN: carlineRun,
                LANE: lane,
                SLOT: slot
            }).then(response => {

                if (response.data.error) {

                    //console.log('error', response.data.error)
                    this.loading = false;

                } else {

                    //console.log('success', response.data)
                    this.loading = false;
                    this.currentStudents = this.currentStudents - 1;
                    this.getCarlineLoop();
                    

                }

            }).catch(error => {

                console.log(error.response)
                this.loading = false;

            });

        },
  sendStudent(pId) {
    console.log(pId);
  },
 
  removeStudent(pId,studentId,firstName,lastName,dob,householdId,hangerId) {

    //console.log(pId);

    var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");

    //console.log(newDate);

  this.$confirm("Are you sure?").then(() => {
  //do something...

 

  const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };

  axios.put('https://api.conciergepadedu.com/api/Apps/PutStudent/' + String(pId),{ 
         ID: pId,
         STUDENT_ID: studentId,
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         BIRTHDAY: dob,
         HOUSEHOLD_ID: householdId,
         HANGER_ID: hangerId,
         ACTIVE_FLAG: 'N',
         REMOVE_DATE: newDate,
         LOGIN_UUID: this.loginUuid,
         DATE_ADDED: newDate
      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR");
          //console.log('error', response.data.error);



      } else {

        //console.log('success', response.data);

        this.getStudents();

        this.$alert("Student Removed Successfully","Remove","success");

      } 

  

        }).catch(error => {

            //console.log("CATCH");
            console.log(error.response);




        });

  });

  

   



    },

    updateUserButton(index) {

        //console.log(this.items[index].firsT_NAME);
        //console.log(this.items[index].lasT_NAME);

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };



  axios.put('https://api.conciergepadedu.com/api/Users/PutPush/' + String(this.items[index].id),{ 
         ID: this.items[index].id,
         USERNAME: this.items[index].username,
         PASSWORD:  this.items[index].password,
         COMPANY_NAME: this.items[index].companY_NAME,
         UUID: this.items[index].uuid,
         MOBILE_PHONE:  this.items[index].mobilE_PHONE,
         FIRST_NAME: this.items[index].firsT_NAME,
         LAST_NAME:this.items[index].lasT_NAME,
         EMAIL: this.items[index].username,
         DOB: this.items[index].dob,
         DATE_CREATED: this.items[index].datE_CREATED,
         HANGER_ID: this.items[index].hangeR_ID,
         PUSH_TOKEN: this.items[index].pusH_TOKEN
      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          //console.log('error', response.data.error);

          this.validUpdate = false;
          this.invalidUpdate = true;

      } else {

      //console.log('success', response.data);
      this.validUpdate = true;
      this.invalidUpdate = false;
      this.getAuthParents();
      this.sendEmail(this.items[index].username);
      
      } 

  

        }).catch(error => {

              console.log(error.response);

              this.validUpdate = false;
              this.invalidUpdate = true;




        });



    },

  uploadParentToApi(firstName,lastName,dob,companyName,studentId,studentRelation,hangerId, authEmail) {

  axios.post('https://api.conciergepadedu.com/api/Parents/PostParent',{ 
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         DOB: dob,
         COMPANY_NAME: companyName,
         AUTH_TYPE: 'Y',
         STUDENT_ID: studentId,
         DATE_ADDED: new Date(),
         STUDENT_RELATION: studentRelation,
         HANGER_ID: hangerId,
         AUTH_EMAIL: authEmail
      }).then(response => {


      if (response.data.error) {

        console.log('error', response.data.error)

      } else {

        console.log('success', response.data)
      }

     }).catch(error => {

        console.log(error.response)

      });

   
    },

    getAuthParents:function() {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      console.log("Bearer " + this.jwsToken)

      axios.get('https://api.conciergepadedu.com/api/Users/GetAuth/' +  this.hangerId + '/' + this.compName,auth).then(response => {


   

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        //console.log(response.data);


        this.items = response.data;
        this.firstName = this.items.firsT_NAME;






        }



        }).catch(error => {

            console.log(error.response)




        });

    },
    sendEmail:function(email) {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      console.log("Bearer " + this.jwsToken)

      axios.get('https://api.conciergepadedu.com/api/Users/SendEmail/' + email,auth).then(response => {


   

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        //console.log("**********************************")

        console.log(response.data);


        }



        }).catch(error => {

            console.log(error.response)




        });

    },
    getStudents:function() {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Apps/GetCarlineData/' +  this.compName + '/' + this.compName,auth).then(response => {

      if (response.data.error) {

          console.log("ERROR")
          //console.log('error', response.data.error)

 

      } else {

        //console.log("**********************************")

        //console.log(response.data);


        this.students = response.data;

        }



        }).catch(error => {

            console.log(error.response)


        });

    },
    getHangerId:function(studentId, householdId, companyName) {
      this.hangerIdArray = [];
      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Hangers/' +  studentId + '/' + householdId + "/" + companyName,auth).then(response => {

      if (response.data.error) {

          //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
          //console.log('error', response.data.error)

          this.studentId = '';
          this.studentDob = '';

          this.$alert("No Household ID Found, please contact school for more information. (error)","Add","error");

         

      } else {

        console.log(">>>>>>>SUCCESS>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

        console.log(response.data);
        this.hangerIdArray = response.data;

     

        if (this.hangerIdArray) {

         this.getStudents();
         
         this.$alert("Student Added Successfully","Add","success");


         } else {

         this.$alert("No Household ID Found, please contact school for more information. (not found)","Add","error");

         }

        this.studentId = '';
        this.studentDob = '';
         

        }



        }).catch(error => {
          
            console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
            console.log(error.response)
            this.studentId = '';
            this.studentDob = '';
            this.$alert("No Household ID Found, please contact school for more information. (catch)","Add","error")


        });

    },
    checkEmailGuardian() {

       if (this.guardianEmail == this.email) {

         this.validEmailGuardian = false;
         this.invalidEmailGuardian = true;
         this.alreadyRegistered = "Already registered as Guardian.  Don't have to input yourself."

       } else {

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = ""

        this.checkGuardian();

       }


    },
    checkGuardian:function() {

      axios.get('https://api.conciergepadedu.com/api/Users/CheckUser/' +  this.guardianEmail).then(response => {

      if (response.data.error) {

         console.log("ERROR");

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = "Email not registered"

      } else {

        console.log(response.data);

        //successful
        this.validEmailGuardian = false;
        this.invalidEmailGuardian = true;
        this.alreadyRegistered = "Email already registered"

        }

        }).catch(error => {

            console.log(error.response)

            this.validEmailGuardian = true;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "Email not registered"

            if (this.guardianEmail.length == 0) {

            this.validEmailGuardian = false;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "";

            }

        });

    },

      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
   font-size: 20px !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 18px;
}

.v-data-table td {
  font-size: 20px;
}
tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }

</style>